import { render } from "./InicioPagina.vue?vue&type=template&id=5b9e7416&scoped=true"
import script from "./InicioPagina.vue?vue&type=script&lang=js"
export * from "./InicioPagina.vue?vue&type=script&lang=js"

import "./InicioPagina.vue?vue&type=style&index=0&id=5b9e7416&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9e7416"]])

export default __exports__